module.exports = __webpack_public_path__ + "141d4a85/img/dollar-icon.35c9d638.svg";